// extracted by mini-css-extract-plugin
export default {"container":"analysis-page_container__xxEte"};